import Location from 'src/models/location/Location'
import Model, { ID, Integer, JsonObject, MODEL_LEVEL } from 'src/models/model'
import Archivable from 'src/models/model/concerns/Archivable'
import Librariable from 'src/models/model/concerns/Librariable'

export default class OrderCollectionDisplayType extends Model {
  static name = 'OrderCollectionDisplayType'

  static deletable = true
  static duplicatable = true
  static paginate = true
  static versioned = true

  static isConfiguration = true

  static level = MODEL_LEVEL.SITE

  static employeeRequiredPermissionCategories = [Model.permissionCategories.Kitchen]

  static define () {
    this.concerns = [Archivable, Librariable]

    this.fields = {
      id: {
        type: ID,
        required: true
      },
      name: {
        type: String,
        required: true
      },
      shouldIncludeRemoteOrders: {
        type: Boolean,
        required: true,
        default: true
      },
      excludeSalesLocations: {
        type: Boolean,
        required: true,
        default: false
      },
      excludeItemSourceLocations: {
        type: Boolean,
        required: true,
        default: false
      },
      readyToCollectExpirationMinutes: {
        type: Integer,
        required: true,
        default: 5
      },
      displayOptions: {
        type: JsonObject,
        mergeDefault: true,
        default () {
          return {
            secondaryLanguage: null,
            showHeadings: true,
            showPendingCount: true
          }
        }
      },
      salesLocations: {
        type: [Location],
        default: () => ([]),
        reference: true
      },
      itemSourceLocations: {
        type: [Location],
        default: () => ([]),
        reference: true
      }
    }
  }

  get secondaryLanguage () {
    return this.displayOptions.secondaryLanguage
  }

  set secondaryLanguage (value) {
    this.displayOptions.secondaryLanguage = value
  }

  get showHeadings () {
    return this.displayOptions.showHeadings
  }

  set showHeadings (value) {
    this.displayOptions.showHeadings = value
  }

  get showPendingCount () {
    return this.displayOptions.showPendingCount
  }

  set showPendingCount (value) {
    this.displayOptions.showPendingCount = value
  }
}
